"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SortOrder = void 0;
var SortOrder;
(function (SortOrder) {
    SortOrder[SortOrder["PRIMARY"] = 1] = "PRIMARY";
    SortOrder[SortOrder["SECONDARY"] = 2] = "SECONDARY";
})(SortOrder || (exports.SortOrder = SortOrder = {}));
